import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

// @mui icons
import Icon from "@mui/material/Icon";

const menus = (): CloudPremisePluginMenu[] => {
    return [
        {
            type: "menu_item",
            name: "Iris",
            key: "iris",
            icon: <Icon fontSize="medium">bolt</Icon>,
            route: "/iris/home",
            privacy: "private",
        },
    ];
};

export default menus;